import en from 'element-ui/lib/locale/lang/en'
import he from 'element-ui/lib/locale/lang/he'
import locale from 'element-ui/lib/locale'
import get from 'lodash/get'
import Vue from 'vue'
import { LanguageApi, ContentsApi } from '@/api/languageApi'

function setElementLocale(lang) {
    locale.use(lang === 'he' ? he : en)
}

const types = {
    SET_LANG_LIST: 'SET_LANG_LIST',
    SET_TRANSLATIONS: 'SET_TRANSLATIONS'
};
const state = {
    languages: [],
    translations: {}
};

const mutations = {
    [types.SET_LANG_LIST]: (state, languages) => {
        state.languages = languages
    },
    [types.SET_TRANSLATIONS]: (state, value) => {
        state.translations = value
    }
};

const actions = {
    async getLanguages({ commit, state }, loadCached) {
        const load = async () => {
            const languages = await LanguageApi.getAll()

            commit(types.SET_LANG_LIST, languages)
        }

        if (loadCached && state.languages && state.languages.length !== 0) {
            load()
        } else {
            await load()
        }
    },
    async setLanguage({ commit, state }, { lang, loadCached }) {
        const load = async () => {
            const dir = get(lang, 'DomainConfig.Direction', 'ltr')
            const locale = lang.locale ? lang.locale : 'en'

            if (dir === 'rtl') {
                Vue.prototype.$rtl.enableRTL()
            } else {
                Vue.prototype.$rtl.disableRTL()
            }
            const translations = await ContentsApi.getAll()
            commit(types.SET_TRANSLATIONS, translations);

            setElementLocale(locale)
        }

        if (loadCached && state.translations && Object.keys(state.translations).length !== 0) {
            load()
        } else {
            await load()
        }
    }
};

const getters = {
    getActiveLanguageID: (state, getter) => {
        return getter.getActiveLanguage.LanguageID
    },
    getActiveLanguage: (state, getters) => {
        const currentDomain = window.location.hostname === 'localhost'?
            process.env.VUE_APP_DEFAULT_DOMAIN_NAME:
            window.location.hostname

        const languageByDomain = getters.getLanguageList.find(language => {
            return language.Domain === currentDomain
        })

        if (languageByDomain !== undefined) {
            return languageByDomain
        } else {
            return getters.getLanguageList.find(language => language.LanguageCode.match(/en|us|US|EN/gm))
                || getters.getLanguageList[0]
                || {}
        }
    },
    getLanguageList: state => {
        return state.languages.map(language => {
            const [locale, iconName] = language.LanguageCode.split('-')

            return {
                ...language,
                abbName: locale.toUpperCase(),
                locale,
                name: language.LanguageName,
                icon: `/img/flags/${iconName}.png`
            }
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
